import React, { useState, useEffect, useRef } from "react";
import '../../src/assets/css/style.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { getCertificateDownload } from "../CertificateService";
import { QRCodeCanvas } from "qrcode.react";
// import { QrReader } from "react-qr-reader";
import { getSignature } from '../CertificateService'
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const EnglishCertificate = () => {
    const certificateRef = useRef();
    const [signatureData, setSignatureData] = useState({});
    const location = useLocation();
    const applicationId = location.state?.applicationId;
    const [certificateDownloadData, setCertificateDownloadData] = useState(null);
    const today = new Date();
    const currentYear = today.getFullYear();
    const [data, setData] = useState({
        "Applicant Name": "",
        "Application id": "",
        "Applied Certficate": "",
        "Pradhan Name": "",
        "Pradhan Designation": "",
        "Gram Panchayat Name": "",
        "Block Name": "",
        "District Name": "",
        "Valid Upto": "",
        "Certificate Validity checking link": ""

    });



    useEffect(() => {


        getCertificateDownload(applicationId).then(function (result) {
            const response = result?.data;
            setCertificateDownloadData(response);

            setData({
                "Applicant Name": response?.ApplicantName || "No Name",
                "Application id": response?.ApplicationId || "No Application Id",
                "Applied Certificate": [
                    response?.CharacterCertificate > 0 ? "Character Certificate" : null,
                    response?.IncomeCertificate > 0 ? "Income Certificate" : null,
                    response?.ResidenceCertificate > 0 ? "Residential Certificate" : null,
                    response?.SamePersonCertificate > 0 ? "Same Person Certificate" : null,
                    response?.DistanceCertificate > 0 ? "Distance Certificate" : null,
                ]
                    .filter(Boolean) // Remove null or falsy values
                    .join(", ") || "No Application Id",
                "Pradhan Name": response?.PradhanName,
                "Pradhan Designation": response?.PradhanDesig,
                "Gram Panchayat Name": response?.GPName,
                "Block Name": response?.BlockName,
                "District Name": response?.District,
                "Valid Upto": response?.ValidDate,
                "redirectUrl": "https://wbpms.in/citizen/#/certificate-check"
            })

            getSignature(response?.GpLGD).then(function (result) {
                const response = result?.data;
                console.log(response, "response");
                setSignatureData(response);
            });
        });
    }, [])


    const imageSrc = `data:image/jpeg;base64,${signatureData?.officerSignature}`;

    const handleDownload = async () => {
        try {
            console.log(certificateRef, "certificateRef.current");

            // Render the component into a canvas with lower resolution
            const canvas = await html2canvas(certificateRef.current, {
                scale: 1, // Reduce scale for smaller resolution
            });

            // Convert the canvas to an image with reduced quality
            const imgData = canvas.toDataURL("image/jpeg", 1); // Use JPEG with 70% quality to reduce size

            // Create a new PDF instance with optimized dimensions
            const pdf = new jsPDF({
                orientation: "portrait",
                unit: "px",
                format: [canvas.width, canvas.height], // Set PDF dimensions to match the canvas
            });

            // Add the image to the PDF with further compression
            pdf.addImage(imgData, "JPEG", 0, 0, canvas.width, canvas.height);

            // Save the PDF
            pdf.save("certificate.pdf");
        } catch (error) {
            console.error("Error generating PDF:", error);
        }
    };


    return (
        <>
            <div class="grid-container xyx" ref={certificateRef} style={{ position: "relative" }}>
                <div class="cell text-center" >
                    <br></br>
                    {/* <br></br> */}
                    <h4 style={{ marginTop: "15px" }}><b>{certificateDownloadData?.GPName}</b></h4>
                    <h5 style={{ marginTop: "-12px" }}><b>{certificateDownloadData?.GPAddress}</b></h5>
                </div>
                <div class="cell">
                    <div class="grid-padding-x grid-x crtno" style={{ marginTop: "60px" }}>
                        <div class="large-6">
                            <p class="text-left">Certificate No: <b>{certificateDownloadData?.ApplicationId}</b></p>
                        </div>
                        <div class="large-6">
                            <p class="text-right">Date: <b>{certificateDownloadData?.ApproveDate}</b></p>
                        </div>
                    </div>

                </div>
                <br></br>
                <div class="cell text-center">
                    <h4 style={{ marginBottom: "20px" }}>
                        <b><u>TO WHOM IT MAY CONCERN</u></b>
                    </h4>
                </div>
                <br></br>
                {/* residence */}
                <div class="grid-x grid-padding-x resi divmargin" style={{ marginBottom: "20px" }}>
                    <div class="cell large-10 medium-10 small-12">
                        <p>
                            This is to certify that <b>{certificateDownloadData?.Gender}</b> <b>{certificateDownloadData?.ApplicantName}</b>, <b>{certificateDownloadData?.RelationGurdian}</b> : <b>{certificateDownloadData?.GurdianName}</b> who resides at  <b>{certificateDownloadData?.Address}</b>, P.O.- <b>{certificateDownloadData?.PostOffice}</b>, P.S.-<b>{certificateDownloadData?.PoliceStation}</b>, District-<b>{certificateDownloadData?.District}</b>, PIN-<b>{certificateDownloadData?.Pin}</b>, is known to me.

                            <br></br><b>{certificateDownloadData?.Gender}</b> <b>{certificateDownloadData?.ApplicantName}</b>, is a permanent resident of at <b>{certificateDownloadData?.Address}</b>, P.O.-<b>{certificateDownloadData?.PostOffice}</b>, P.S.-<b>{certificateDownloadData?.PoliceStation}</b>, District-<b>{certificateDownloadData?.District}</b>, PIN-<b>{certificateDownloadData?.Pin}</b>, State- West Bengal.
                        </p>
                    </div>
                 

                        <div class="cell large-2 medium-2 small-12 text-right">
                            <img src={certificateDownloadData?.ApplicantImageBase64} style={{ width: "100%", border: "1px solid #000", padding: "5px", marginTop: "-40px" }} />
                        </div> 
                </div>
                {/* unmarried certificate */}
                {certificateDownloadData?.UnmarriedCertificate > 0 ?
                    <div class="grid-x grid-padding-x income divmargin" style={{ marginBottom: "20px" }}>
                        <div class="cell large-12 medium-12 small-12">
                            <p>
                                To the best of my knowledge, <b>{certificateDownloadData?.Gender === "Mr." ? "He" : "She"}</b>  is currently unmarried.
                            </p>
                        </div>
                    </div>
                    : ""}

                {/* caste certificate */}

                {certificateDownloadData?.CastCertificate > 0 ?
                    <div class="grid-x grid-padding-x income divmargin" style={{ marginBottom: "20px" }}>
                        <div class="cell large-12 medium-12 small-12">
                            <p>
                                <b>{certificateDownloadData?.Gender === "Mr." ? "He" : "She"}</b> belongs to the <b>{certificateDownloadData?.SubCast}</b> community under the <b>{certificateDownloadData?.Cast}</b> category.
                            </p>
                        </div>
                    </div>
                    : ""}

                {/* income */}
                {certificateDownloadData?.IncomeCertificate > 0 ?
                    <div class="grid-x grid-padding-x income divmargin" style={{ marginBottom: "20px" }}>
                        <div class="cell large-12 medium-12 small-12">
                            <p>
                                <b>{certificateDownloadData?.Gender === "Mr." ? "His" : "Her"}</b> total annual family income from all sources for the Financial Year <b>{certificateDownloadData?.IncomeFinYear}</b> does not exceed Rs. <b>{certificateDownloadData?.AnnualIncome}</b>/- (Rupees <b>{certificateDownloadData?.AnnualIncomeWord}</b>).
                            </p>
                        </div>
                    </div> : ""}

                {/* distance */}
                {certificateDownloadData?.DistanceCertificate > 0 ?

                    <div class="grid-x grid-padding-x distance divmargin" style={{ marginBottom: "20px" }}>
                        <div class="cell large-12 medium-12 small-12">
                            <p>
                                The approximate distance between <b>{certificateDownloadData?.Gender === "Mr." ? "his" : "her"}</b> residence and <b>{certificateDownloadData?.ResidenceLocation}</b> is <b>{certificateDownloadData?.ResidenceDistance}</b> kilometers.
                            </p>
                        </div>
                    </div> : ""}
                {/* same person */}
                {certificateDownloadData?.SamePersonCertificate > 0 ?

                    <div class="grid-x grid-padding-x same divmargin" style={{ marginBottom: "20px" }}>
                        <div class="cell large-12 medium-12 small-12">
                            <p>
                                <b>{certificateDownloadData?.Gender}</b> <b>{certificateDownloadData?.SamePersonOldName}</b> and <b>{certificateDownloadData?.Gender}</b> <b>{certificateDownloadData?.SamePersonNewName}</b> are the names of the same person. <b>{certificateDownloadData?.Gender === "Mr." ? "His" : "Her"}</b> <b>{certificateDownloadData?.RelationGurdian}</b> is <b>{certificateDownloadData?.GurdianName}</b>. <b>{certificateDownloadData?.Gender === "Mr." ? "His" : "Her"}</b> date of birth is <b>{certificateDownloadData?.DOB}</b>.
                            </p>
                        </div>
                    </div> : ""}
                {/* charecter */}
                {certificateDownloadData?.CharacterCertificate > 0 ?

                    <div class="grid-x grid-padding-x character divmargin" style={{ marginBottom: "20px" }}>
                        <div class="cell large-12 medium-12 small-12">
                            <p>
                                <b>{certificateDownloadData?.Gender === "Mr." ? "He" : "She"}</b> possesses a commendable moral character. I wish <b>{certificateDownloadData?.Gender === "Mr." ? "him" : "her"}</b> every success in life.
                            </p>
                        </div>
                    </div> : ""}

                <div class="cell">
                    <div class="grid-padding-x grid-x">
                        <div class="large-6 cell text-center">

                            <QRCodeCanvas value={JSON.stringify(data)}

                                size={100}
                            />
                            <p class="text-center" style={{ fontSize: "10px" }}><i>https://wbpms.in</i></p>
                            <p class="text-center" style={{ fontSize: "10px" }}><i>Certificate Valid for 6 Months</i></p>
                        </div>

                        <div class="large-6 cell" style={{ marginTop: "30px" }}>
                            <div>
                                {certificateDownloadData?.ApplicantImageBase64 ?
                                    <img
                                        src={imageSrc}
                                        alt="Signature"
                                        style={{
                                            height: "auto",
                                            position: "relative", // Aligns with the div
                                            top: "-2px",
                                            right: "-110px",
                                            maxWidth: "150px",

                                            // Moves the image upwards to touch the border
                                        }}
                                    /> :
                                    <img
                                        src={imageSrc}
                                        alt="Signature"
                                        style={{
                                            height: "auto",
                                            position: "relative", // Aligns with the div
                                            top: "-2px",
                                            right: "-110px",
                                            maxWidth: "150px",

                                            // Moves the image upwards to touch the border
                                        }}
                                    />
                                }
                            </div>
                            <p class="text-center"> <b>{signatureData?.officerName}</b></p>
                            <p class="text-center"> <b>{certificateDownloadData?.PradhanDesig}</b></p>
                            <p class="text-center"> <b>{certificateDownloadData?.GPName}</b></p>
                            <p class="text-center"> <b>{certificateDownloadData?.BlockName}, {certificateDownloadData?.District}</b></p>

                        </div>
                    </div>
                </div>
                <p style={{ bottom: "170px", position: "absolute", fontSize: "12px" }}><i>To verify the authenticity of this certificate, please visit https://wbpms.in/citizen/#/certificate-check</i></p>
            </div>
            {certificateDownloadData?.ApplicantImageBase64 ?
                <div>
                    <br></br>
                    <button

                        onClick={handleDownload}
                        className="btn mt-4 bg-blue-500 text-white px-4 py-2 rounded"
                        style={{ marginLeft: "700px" }}
                    >
                        {/* {certificateDownloadData?.SaveDate} */}
                        Download Certificate
                    </button>
                </div>
                : ""}
        </>
    )
}

export default EnglishCertificate;